// Story Feed
export const STORY_FEED_REQUEST = "STORY_FEED_REQUEST";
export const STORY_FEED_SUCCESS = "STORY_FEED_SUCCESS";
export const STORY_FEED_FAIL = "STORY_FEED_FAIL";
export const STORY_FEED_RESET = "STORY_FEED_RESET";

// User Stories
export const USER_STORIES_REQUEST = "USER_STORIES_REQUEST";
export const USER_STORIES_SUCCESS = "USER_STORIES_SUCCESS";
export const USER_STORIES_FAIL = "USER_STORIES_FAIL";
export const USER_STORIES_RESET = "USER_STORIES_RESET";

// Archived Stories
export const ARCHIVED_STORIES_REQUEST = "ARCHIVED_STORIES_REQUEST";
export const ARCHIVED_STORIES_SUCCESS = "ARCHIVED_STORIES_SUCCESS";
export const ARCHIVED_STORIES_FAIL = "ARCHIVED_STORIES_FAIL";

// New Story
export const NEW_STORY_REQUEST = "NEW_STORY_REQUEST";
export const NEW_STORY_SUCCESS = "NEW_STORY_SUCCESS";
export const NEW_STORY_FAIL = "NEW_STORY_FAIL";
export const NEW_STORY_RESET = "NEW_STORY_RESET";

// View Story
export const VIEW_STORY_REQUEST = "VIEW_STORY_REQUEST";
export const VIEW_STORY_SUCCESS = "VIEW_STORY_SUCCESS";
export const VIEW_STORY_FAIL = "VIEW_STORY_FAIL";

// Like Story
export const LIKE_STORY_REQUEST = "LIKE_STORY_REQUEST";
export const LIKE_STORY_SUCCESS = "LIKE_STORY_SUCCESS";
export const LIKE_STORY_FAIL = "LIKE_STORY_FAIL";

// Delete Story
export const DELETE_STORY_REQUEST = "DELETE_STORY_REQUEST";
export const DELETE_STORY_SUCCESS = "DELETE_STORY_SUCCESS";
export const DELETE_STORY_FAIL = "DELETE_STORY_FAIL";
export const DELETE_STORY_RESET = "DELETE_STORY_RESET";

// Highlights
export const USER_HIGHLIGHTS_REQUEST = "USER_HIGHLIGHTS_REQUEST";
export const USER_HIGHLIGHTS_SUCCESS = "USER_HIGHLIGHTS_SUCCESS";
export const USER_HIGHLIGHTS_FAIL = "USER_HIGHLIGHTS_FAIL";

export const HIGHLIGHT_STORIES_REQUEST = "HIGHLIGHT_STORIES_REQUEST";
export const HIGHLIGHT_STORIES_SUCCESS = "HIGHLIGHT_STORIES_SUCCESS";
export const HIGHLIGHT_STORIES_FAIL = "HIGHLIGHT_STORIES_FAIL";
export const HIGHLIGHT_STORIES_RESET = "HIGHLIGHT_STORIES_RESET";

export const NEW_HIGHLIGHT_REQUEST = "NEW_HIGHLIGHT_REQUEST";
export const NEW_HIGHLIGHT_SUCCESS = "NEW_HIGHLIGHT_SUCCESS";
export const NEW_HIGHLIGHT_FAIL = "NEW_HIGHLIGHT_FAIL";
export const NEW_HIGHLIGHT_RESET = "NEW_HIGHLIGHT_RESET";

export const DELETE_HIGHLIGHT_REQUEST = "DELETE_HIGHLIGHT_REQUEST";
export const DELETE_HIGHLIGHT_SUCCESS = "DELETE_HIGHLIGHT_SUCCESS";
export const DELETE_HIGHLIGHT_FAIL = "DELETE_HIGHLIGHT_FAIL";
export const DELETE_HIGHLIGHT_RESET = "DELETE_HIGHLIGHT_RESET";

export const UPDATE_HIGHLIGHT_REQUEST = "UPDATE_HIGHLIGHT_REQUEST";
export const UPDATE_HIGHLIGHT_SUCCESS = "UPDATE_HIGHLIGHT_SUCCESS";
export const UPDATE_HIGHLIGHT_FAIL = "UPDATE_HIGHLIGHT_FAIL";
export const UPDATE_HIGHLIGHT_RESET = "UPDATE_HIGHLIGHT_RESET";

// Clear Errors
export const CLEAR_ERRORS = "CLEAR_ERRORS";
